import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as UserCheck } from "feather-icons/dist/icons/user-check.svg";
/*import TeamIllustrationSrc from "images/team-illustration-2.svg";
import { ReactComponent as TwitterIcon} from "images/twitter-icon.svg";
import { ReactComponent as LinkedinIcon} from "images/linkedin-icon.svg";
import { ReactComponent as GithubIcon } from "images/github-icon.svg";*/

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-auto md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);


const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Features = tw.div`mt-8 max-w-sm mx-auto md:mx-0`;
const Feature = tw.div`mt-8 flex items-start flex-col md:flex-row`;

const FeatureIconContainer = styled.div`
  ${tw`mx-auto inline-block border border-primary-500 text-center rounded-full p-2 flex-shrink-0`}
  svg {
    ${tw`w-5 h-5 text-primary-500`}
  }
`;

const FeatureText = tw.div`mt-4 md:mt-0 md:ml-4 text-center md:text-left`;
const FeatureHeading = tw.div`font-bold text-lg text-primary-500`;
const FeatureDescription = tw.div`mt-1 text-sm`;


const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`
const Card = tw.div`mt-5 w-full sm:w-1/2 lg:w-1/2 flex flex-col items-center`

const CardPlaceholder = styled.div`
  ${tw`w-20 h-20 rounded-full relative inline-flex items-center justify-center overflow-hidden bg-gray-100`}
`;
const CardPlaceholderText = styled.span`
  ${tw`font-medium text-3xl text-primary-500`}
`;
const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase font-bold tracking-widest text-xs text-primary-500`}
  }
  .name {
    ${tw`mt-1 text-xl font-medium text-gray-900`}
  9
`

const Contact = styled.div`
  ${tw`mt-1 text-xs`}
`
export default ({
  subheading = "Experiência",
  heading = (
    <>
      Conheça a nossa equipa <span tw="text-primary-500">competência e compromisso</span> ao seu dispor.
    </>
  ),
  description = "A nossa equipa é a força motriz por trás de cada serviço que prestamos. Com profissionais experientes e dedicados, garantimos soluções eficazes e um serviço de qualidade superior, trabalhamos em conjunto para satisfazer as necessidades específicas de cada condomínio. ",
  features = null,
  textOnLeft = true,
  cards = [
    {
       position: "Sócia-Gerente",
      name: "Linda Borges",
      placeholder: "LB",
      email: "linda.borges@condofraccoes.pt",
      contact: "966218629"
    },
    {
      position: "Sócia-Gerente",
      name: "Sandrina Almeida",
      placeholder: "SA",
      email: "sandrina.almeida@condofraccoes.pt",
      contact: "935459260"
    },
    {
      position: "Contabilista/Administrativa ",
      name: "Mariana Dias",
      placeholder: "MD",
      email: "geral@condofraccoes.pt",
      contact: "935459255"
    },
  ]
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

  /*
   * Change the features variable as you like, add or delete objects
   * `icon` must be a React SVG component. See how BriefcaseIcon is imported above. For a full list of available icons, see Feather Icons.
   */
  const defaultFeatures = [
    {
      Icon: BriefcaseIcon,
      title: "Profissionalismo",
      description: "Asseguramos uma gestão condominial eficaz e de confiança, adaptada às necessidades específicas de cada cliente."
    },
    {
      Icon: MoneyIcon,
      title: "Preços acessíveis",
      description: "Comprometemo-nos a oferecer-lhe a melhor tarifa possível - alinhada com as práticas do setor"
    },
    {
      Icon: UserCheck,
      title: "Proximidade",
      description: "Devido à nossa estrutura familiar sabe sempre a quem recorrer."
    }
  ];

  if (!features) features = defaultFeatures;

  return (
    <Container id='sobre'>
      <TwoColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Subheading>{subheading}</Subheading>
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            <Features>
              {features.map((feature, index) => (
                <Feature key={index}>
                  <FeatureIconContainer>{<feature.Icon />}</FeatureIconContainer>
                  <FeatureText>
                    <FeatureHeading>{feature.title}</FeatureHeading>
                    <FeatureDescription>{feature.description}</FeatureDescription>
                  </FeatureText>
                </Feature>
              ))}
            </Features>
          </TextContent>
        </TextColumn>
        <ImageColumn>
        <Cards>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardPlaceholder>
                <CardPlaceholderText>{card.placeholder}</CardPlaceholderText>
              </CardPlaceholder>
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name">{card.name}</span>
                <Contact>{card.email}</Contact>
                <Contact>{card.contact}</Contact>
              </CardContent>
            </Card>
          ))}
        </Cards>
        </ImageColumn>
      </TwoColumn>
    </Container>
  );
};
